import "./styles.scss";
import React, { FC } from "react";
import SocialIcon from "SocialIcon/SocialIcon";
import "./styles.scss";

interface IProps {
  avatar: string;
  name: string;
  job: string;
  linkedin_url: string;
  company: { name: string; company_id: string };
}

const CompanyTeamItem: FC<IProps> = (props: IProps) => {
  const { avatar, name, job, linkedin_url, company } = props;
  const errorAvatar = <img src="/images/headshot-placeholder.png" alt={name} />;

  return (
    <div className="ps-company-team-item__avatar-name-container">
      <div className="ps-company-team-item__avatar-wrapper">
        <img
          src={avatar || "/images/headshot-placeholder.png"}
          alt={name}
          onError={() => errorAvatar}
        />
      </div>
      <div className="ps-company-team-item__name-title-container">
        <span className="ps-company-team-item__name">{name !== "null" ? name : ""}</span>
        <span className="ps-company-team-item__job-title">{job}</span>
      </div>
      <div className="ps-company-team-item__social-logo-container">
        {linkedin_url && (
          <SocialIcon
            iconType="linkedin"
            size="small"
            href={linkedin_url}
            companyName={company.name}
            companyId={company.company_id}
          />
          // <img src={linkedin_url} alt={name} onError={() => errorAvatar}/>
        )}
      </div>
    </div>
  );
};

export default CompanyTeamItem;
